module.exports = __webpack_public_path__ + "img/hr-rock-huge-19.ac4a6c46.png";